import { IconType } from '@/types';

export default function BuyerIcon({ className, width = 24, height = 24 }: IconType) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.8333 11.5417L21.9309 14.25M21.9309 14.25L20.6667 18.0417H15.7917L14.7083 14.25H21.9309ZM16.875 20.2192L16.8858 20.2073M20.125 20.2192L20.1358 20.2073M8.75 9.91667C9.89927 9.91667 11.0015 9.46012 11.8141 8.64746C12.6268 7.83481 13.0833 6.73261 13.0833 5.58333C13.0833 4.43406 12.6268 3.33186 11.8141 2.5192C11.0015 1.70655 9.89927 1.25 8.75 1.25C7.60073 1.25 6.49853 1.70655 5.68587 2.5192C4.87321 3.33186 4.41666 4.43406 4.41666 5.58333C4.41666 6.73261 4.87321 7.83481 5.68587 8.64746C6.49853 9.46012 7.60073 9.91667 8.75 9.91667Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.16666 17.5C1.16668 16.0766 1.56731 14.6819 2.32273 13.4755C3.07814 12.2691 4.15784 11.2997 5.43834 10.6781C6.71884 10.0565 8.14843 9.80783 9.56361 9.96055C10.9788 10.1133 12.3224 10.6612 13.4408 11.5417'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
